import React from 'react';
import './App.css';
import {Box, createTheme, ThemeProvider} from "@mui/material";
import {Outlet} from "react-router-dom";
import Footer from "../Footer/Footer";
import ResponsiveToolbar from "../ResponsiveToolbar/ResponsiveToolbar";
import GlobalMessage from "../GlobalMessage/GlobalMessage";
import {GoogleReCaptchaProvider} from "react-google-recaptcha-v3";

// Create a theme instance.
const theme = createTheme({
    palette: {
        primary: {
            main: 'rgb(36,28,35)', // Replace with your desired color
        },
        secondary: {
            main: 'rgba(210,28,36,1)', // Replace with your desired color
        },
    },
    components: {
        MuiDivider: {
            styleOverrides: {
                root: {
                    backgroundColor: 'rgba(235,28,36, 0.2)', // Replace with your desired color
                },
            },
        },
    },
});

function App() {

  return (
      <ThemeProvider theme={theme}>
          <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || ''}>
              <ResponsiveToolbar />
              <GlobalMessage />
              <Box style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh'}}>
                  <Box sx={{flex: 1, mb: 3}}>
                      <Outlet />
                  </Box>
                  <Footer />
              </Box>
          </GoogleReCaptchaProvider>
      </ThemeProvider>
  );
}

export default App;
